import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { SLImage } from "../slimage"
import styles from "./slider.module.css"

export function SLSlider({ images }: { images: Array<any> }) {
  return (
    <Carousel
      className={styles.carousel}
      showThumbs={false}
      showArrows={true}
      transitionTime={700}
      interval={8000}
      autoPlay={true}
      infiniteLoop={true}
      swipeable={true}
    >
      {images.map(node => (
        <div className={styles.imgContainer} key={node.title}>
          <SLImage
            className={styles.imgInside}
            src={node.fluid.src}
            alt={node.description}
          />
        </div>
      ))}
    </Carousel>
  )
}
